import apiClient from "../apiClient";

export const MediaAPI = {
  createMedia: (formData) => apiClient.post("/api/v1/media/upload", formData),
  createAdminMedia: (formData) => apiClient.post("/api/v1/media/admin-upload", formData)
};
